import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconThumbtack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#009fd9",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", { d: "M11.97 0a11.97 11.97 0 1 0 0 23.94 11.97 11.97 0 0 0 0-23.94" }), /* @__PURE__ */ _jsx("path", {
			fill: "#FFF",
			d: "M13.4 16.41a6.17 6.17 0 0 1-.83 3.08l-.6 1.04-.6-1.04a6.17 6.17 0 0 1-.82-3.08v-4.95a3.33 3.33 0 0 1 2.84-1.33v6.28zm-7.28-7.4V6.36h11.7v2.67H6.12z"
		})]
	})
});
export default SvgIconThumbtack;
